import {
  EventNames,
  TrackingEventTypes,
  useAnalytics,
} from '@cinch-nx/shared-analytics'
import { RecentlyViewedCarsCarousel } from '@cinch-nx/shared-cars-carousel'
import { Tabs } from '@cinch-nx/shared-ui'
import { CarsCarousel } from '@cinch-nx/storyblok'
import { StoryblokRenderer } from '@cinch-nx/storyblok-utils'
import { SbBlokData } from '@storyblok/react'
import React, { useEffect } from 'react'

const tabButtonTrackingEvent = (tabTitle: string) => ({
  eventName: `Personalised Component`,
  type: TrackingEventTypes.ADOBE,
  data: {
    event: {
      name: EventNames.click,
      category: 'Personalised Component',
      label: `${tabTitle} tab`,
      action: 'Tab Clicked',
    },
  },
})

type ReturningCustomerTabsProps = {
  newCarsTab: SbBlokData
}

export const ReturningCustomerTabs: React.FC<ReturningCustomerTabsProps> = ({
  newCarsTab,
}) => {
  const { trackEvent } = useAnalytics()

  useEffect(() => {
    setTimeout(() => {
      trackEvent({
        eventName: 'Welcome back module',
        type: TrackingEventTypes.PAGE,
        data: {
          event: {
            category: 'welcome-back-module',
            label: 'personalised-component',
            action: 'triggered',
            name: 'load',
          },
        },
      })
    }, 3000)
  }, [])

  return (
    <Tabs
      ariaLabel="recently-viewed-and-new-cars-list"
      content={[
        {
          label: 'Recently viewed',
          onTabClick: () =>
            trackEvent(tabButtonTrackingEvent('Recently viewed')),
          panelContent: (
            <RecentlyViewedCarsCarousel showBrowseAllCarsCard={true} />
          ),
        },
        {
          label: 'New cars',
          onTabClick: () => trackEvent(tabButtonTrackingEvent('New cars')),
          panelContent: (
            <StoryblokRenderer
              block={newCarsTab}
              components={{ CarsCarousel }}
            />
          ),
        },
      ]}
    />
  )
}
